import { PageHero } from "@/components/site/PageHero";
import { ServiceCard } from "@/components/site/ServiceCard";
import { CTABanner } from "@/components/site/CTABanner";
import { Seo } from "@/components/site/Seo";
import { RESIDENTIAL_SERVICES } from "@/lib/site";

const Residential = () => (
  <>
    <Seo
      title="Residential Cleaning Sydney | House, Deep, Bond & Airbnb Cleaning | Oz SpotNest"
      description="Residential cleaning services across Sydney, NSW — regular domestic cleaning, deep/spring cleaning, end-of-lease bond cleaning and Airbnb turnover cleaning. Request a free quote."
    />
    <PageHero
      eyebrow="Residential Cleaning"
      title="A cleaner home,"
      highlight="without the hassle"
      description="Whether you need regular help keeping your home tidy, a detailed deep clean, an end-of-lease clean or a fast Airbnb turnover, we offer flexible residential cleaning services to suit your property."
    />
    <section className="section-pad" data-testid="residential-services-list">
      <div className="container-site grid gap-8 md:grid-cols-2">
        {RESIDENTIAL_SERVICES.map((s, i) => (
          <ServiceCard key={s.id} service={s} index={i} />
        ))}
      </div>
    </section>
    <CTABanner
      heading="Ready for a Cleaner Home?"
      text="Tell us about your property and the cleaning you need — we'll come back with a clear, obligation-free quote."
      ctaLabel="Get Your Free Quote"
    />
  </>
);

export default Residential;
